export const rankingData = [
  { rank: 1, title: '某顶流男星深夜密会神秘女子', heat: '980万', tag: '爆', trend: 'up' },
  { rank: 2, title: '热播综艺录制现场突发意外状况', heat: '860万', tag: '热', trend: 'up' },
  { rank: 3, title: '知名导演新片选角引发粉丝大战', heat: '720万', tag: '热', trend: 'up' },
  { rank: 4, title: '当红小花被曝与经纪人关系不和', heat: '650万', tag: '新', trend: 'down' },
  { rank: 5, title: '网红直播带货翻车惹众怒', heat: '580万', tag: '新', trend: 'up' },
];

export const cardsData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Soft%20warm%20gradient%20abstract%20background%20with%20subtle%20entertainment%20news%20photography%20aesthetic%2C%20editorial%20magazine%20vibe%2C%20cream%20and%20warm%20beige%20tones%2C%20minimal%20composition%20with%20gentle%20light%20textures%2C%20professional%20yet%20approachable%20style%2C%20clean%20modern%20design%20with%20soft%20ambient%20lighting&width=800&height=560&seq=card-gossip-01&orientation=landscape',
    title: '顶流明星恋情大曝光：深夜约会画面流出',
    excerpt: '据知情人士透露，某当红顶流男星近日被拍到与圈外女性深夜同行，举止亲密引发全网猜测。',
    time: '2小时前',
    views: '128万',
    category: '明星八卦',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20art%20with%20entertainment%20industry%20vibe%2C%20soft%20curves%20and%20flowing%20lines%2C%20peach%20and%20cream%20color%20palette%2C%20elegant%20magazine%20editorial%20backdrop%2C%20subtle%20texture%20overlay%2C%20warm%20ambient%20glow%2C%20clean%20sophisticated%20composition&width=800&height=560&seq=card-gossip-02&orientation=landscape',
    title: '热播剧男主被曝片场耍大牌，导演组回应',
    excerpt: '某热播古装剧男主角近日陷入争议，多位剧组工作人员匿名爆料其片场行为不当，导演组已作出回应。',
    time: '4小时前',
    views: '96万',
    category: '影视圈',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20inspired%20by%20social%20media%20trends%2C%20soft%20coral%20and%20terracotta%20hues%2C%20modern%20lifestyle%20magazine%20aesthetic%2C%20smooth%20geometric%20shapes%20with%20gentle%20lighting%2C%20fashionable%20editorial%20composition%2C%20clean%20minimal%20design&width=800&height=560&seq=card-gossip-03&orientation=landscape',
    title: '网红情侣分手内幕：财产纠纷闹上法庭',
    excerpt: '知名网红CP突然宣布分手，随后被曝出涉及千万级别的共同财产分割问题，目前案件已进入司法程序。',
    time: '6小时前',
    views: '85万',
    category: '网红动态',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20style%20abstract%20with%20warm%20amber%20and%20cream%20tones%2C%20soft%20diffused%20light%2C%20clean%20studio%20aesthetic%2C%20subtle%20fabric%20texture%20backdrop%2C%20professional%20magazine%20layout%20vibe%2C%20elegant%20minimal%20composition%20with%20gentle%20gradients&width=800&height=560&seq=card-gossip-04&orientation=landscape',
    title: '综艺录制现场意外，多位嘉宾紧急送医',
    excerpt: '某热门综艺节目录制过程中发生舞台事故，导致包括常驻嘉宾在内的多人受伤，节目组已紧急暂停录制。',
    time: '8小时前',
    views: '73万',
    category: '综艺',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20composition%20with%20entertainment%20and%20media%20theme%2C%20soft%20peach%20and%20sand%20color%20palette%2C%20smooth%20flowing%20forms%2C%20editorial%20magazine%20background%2C%20gentle%20light%20play%2C%20clean%20modern%20aesthetic%20with%20subtle%20warmth&width=800&height=560&seq=card-gossip-05&orientation=landscape',
    title: '乐坛天后疑似婚变，社交平台删除合照',
    excerpt: '歌坛天后近日被网友发现在社交媒体上清空了与丈夫的所有合影，引发婚变猜测，双方工作室保持沉默。',
    time: '10小时前',
    views: '69万',
    category: '明星八卦',
  },
];

export const updatesData = [
  { time: '14:32', content: '某选秀节目选手被曝学历造假，节目组发表声明将彻查', tag: '爆料' },
  { time: '13:15', content: '热门IP改编剧官宣主演阵容，网友评价两极分化', tag: '官宣' },
  { time: '11:48', content: '知名主持人被拍到与神秘男子同游三亚', tag: '偷拍' },
  { time: '10:20', content: '某品牌代言人合约到期，多位明星争抢代言机会', tag: '商业' },
  { time: '09:05', content: '电影票房最新战报：暑期档冠军基本锁定', tag: '数据' },
  { time: '08:30', content: '一线女星深夜发文疑似回应争议话题', tag: '回应' },
  { time: '07:15', content: '短视频平台网红因不当言论被禁言处理', tag: '处罚' },
  { time: '06:00', content: '海外知名电影节公布入围名单，三部华语片入选', tag: '国际' },
];

export const aboutData = {
  title: '吃瓜在线 — 你的娱乐八卦第一站',
  paragraphs: [
    '吃瓜在线成立于2020年，是国内领先的娱乐八卦与热点资讯聚合平台。我们以"让吃瓜更专业"为使命，致力于为用户提供最新、最全、最热的51国产吃瓜在线今日吃瓜内容，涵盖明星动态、网红八卦、综艺花絮、影视资讯等多个领域。',
    '平台拥有专业的内容编辑团队和智能推荐算法，每日24小时不间断更新今日吃瓜爆料和今日吃瓜最新动态，确保用户第一时间获取实时八卦信息。无论是今日吃瓜在线观看还是51吃瓜视频在线观看，吃瓜在线都是你身边最贴心的吃瓜伙伴。',
    '我们坚持"快、准、全"的内容理念，所有资讯均经过多重核实，在追求速度的同时保障内容的真实性和可靠性。吃瓜在线已累计服务超过5000万吃瓜群众，日均内容更新量超过2000条。',
    '从娱乐圈大事到网红圈八卦，从影视剧透到综艺爆料，吃瓜在线为你提供一站式吃瓜体验，让你不错过每一个精彩瞬间。',
  ],
  stats: [
    { value: '5000万+', label: '累计用户' },
    { value: '2000+', label: '日更新内容' },
    { value: '98%', label: '内容真实率' },
    { value: '30秒', label: '平均响应' },
  ],
};

export const topicsData = [
  { name: '顶流恋情', heat: '980万', color: 'primary' },
  { name: '综艺事故', heat: '860万', color: 'accent' },
  { name: '明星婚变', heat: '750万', color: 'secondary' },
  { name: '网红翻车', heat: '680万', color: 'primary' },
  { name: '票房战报', heat: '620万', color: 'accent' },
  { name: '选秀争议', heat: '550万', color: 'secondary' },
  { name: '代言争夺', heat: '480万', color: 'primary' },
  { name: '片酬揭秘', heat: '420万', color: 'accent' },
  { name: '剧组内幕', heat: '380万', color: 'secondary' },
  { name: '时尚穿搭', heat: '350万', color: 'primary' },
];

export const commentsData = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20portrait%20style%20abstract%20profile%2C%20warm%20peach%20tones%2C%20soft%20circular%20composition%2C%20clean%20minimal%20design%2C%20gentle%20gradient%20background%2C%20simple%20geometric%20avatar%20aesthetic&width=120&height=120&seq=avatar-comment-01&orientation=squarish',
    name: '吃瓜不嫌事大',
    time: '3分钟前',
    content: '这瓜保熟吗？不过看这阵势八成是真的，坐等官方回应！现在娱乐圈真是三天一小瓜五天一大瓜。',
    likes: 2836,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20profile%20icon%2C%20warm%20coral%20and%20cream%20tones%2C%20soft%20circular%20design%2C%20clean%20geometric%20composition%2C%20gentle%20color%20palette%2C%20simple%20modern%20avatar%20style&width=120&height=120&seq=avatar-comment-02&orientation=squarish',
    name: '八卦研究员',
    time: '15分钟前',
    content: '我就说之前看节目觉得不对劲，果然出事了。希望受伤的嘉宾都平安吧，安全第一。',
    likes: 1852,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20profile%20illustration%2C%20warm%20terracotta%20and%20sand%20tones%2C%20soft%20circular%20form%2C%20clean%20geometric%20style%2C%20simple%20modern%20avatar%20design%2C%20gentle%20color%20gradient&width=120&height=120&seq=avatar-comment-03&orientation=squarish',
    name: '理性吃瓜人',
    time: '28分钟前',
    content: '大家理性吃瓜，没有实锤之前还是不要乱传。不过这届网友的侦察能力是真的强。',
    likes: 1523,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20profile%20circle%2C%20warm%20amber%20and%20beige%20tones%2C%20soft%20geometric%20composition%2C%20clean%20simple%20avatar%20design%2C%20gentle%20gradient%20background%2C%20modern%20minimal%20style&width=120&height=120&seq=avatar-comment-04&orientation=squarish',
    name: '追剧小达人',
    time: '42分钟前',
    content: '刚看完那部剧就出这新闻，我的CP不会要塌房吧？求求了让我安心追个剧。',
    likes: 1208,
  },
];

export const appData = {
  title: '随时随地，吃瓜不停',
  subtitle: '下载吃瓜在线APP，第一时间获取最新八卦资讯',
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20modern%20entertainment%20news%20app%20interface%20with%20warm%20color%20scheme%2C%20clean%20UI%20design%20with%20card%20layout%2C%20mobile%20screen%20on%20soft%20cream%20background%2C%20editorial%20news%20feed%20style%2C%20minimal%20and%20elegant%20app%20design%2C%20warm%20peach%20and%20coral%20accents&width=700&height=1200&seq=app-mockup-chigua&orientation=portrait',
  features: ['实时推送', '视频专区', '话题讨论', '离线阅读'],
};

export const mediaData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20toned%20abstract%20video%20thumbnail%20style%2C%20entertainment%20news%20visual%2C%20soft%20dramatic%20lighting%2C%20editorial%20composition%20with%20play%20button%20area%2C%20rich%20amber%20and%20cream%20colors%2C%20modern%20media%20player%20aesthetic%2C%20clean%20professional%20design&width=800&height=500&seq=media-gossip-01&orientation=landscape',
    title: '顶流明星街头被拍：全副武装仍被认出',
    duration: '03:25',
    views: '256万',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20light%20abstract%20video%20cover%20design%2C%20entertainment%20media%20thumbnail%2C%20soft%20glowing%20highlights%2C%20peach%20and%20terracotta%20tones%2C%20modern%20video%20player%20layout%2C%20editorial%20style%20with%20clean%20composition%2C%20professional%20media%20aesthetic&width=800&height=500&seq=media-gossip-02&orientation=landscape',
    title: '独家揭秘：综艺幕后不为人知的秘密',
    duration: '08:12',
    views: '189万',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20warm%20abstract%20video%20thumbnail%2C%20entertainment%20documentary%20style%2C%20soft%20golden%20hour%20lighting%20effect%2C%20coral%20and%20sand%20colors%2C%20modern%20media%20presentation%2C%20clean%20cinematic%20composition%20with%20ambient%20glow%2C%20professional%20editorial%20design&width=800&height=500&seq=media-gossip-03&orientation=landscape',
    title: '网红圈年度大瓜合集：一个比一个精彩',
    duration: '12:48',
    views: '312万',
  },
];

export const featuresData = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '24小时不间断追踪娱乐圈最新动态，重大事件发生30秒内推送通知，让你永远快人一步掌握今日吃瓜最新资讯。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '内容核实',
    desc: '专业编辑团队多重核实每一条今日吃瓜爆料，坚决杜绝虚假信息传播，做最值得信赖的51国产吃瓜在线平台。',
  },
  {
    icon: 'ri-live-line',
    title: '视频专区',
    desc: '提供海量51吃瓜视频在线观看内容，涵盖明星采访、综艺花絮、活动现场等独家视频资源，沉浸式吃瓜体验。',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: '瓜友社区',
    desc: '数百万吃瓜群众聚集地，畅聊今日吃瓜在线观看感受，参与话题讨论，发表你的独特见解和八卦观点。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端覆盖',
    desc: '支持Web端、移动端多平台访问，随时随地打开吃瓜在线观看最新内容，通勤路上也不错过任何精彩八卦。',
  },
];

export const indexData = [
  { title: '明星恋情专题', count: 128, icon: 'ri-heart-line', color: 'primary' },
  { title: '综艺爆料合集', count: 96, icon: 'ri-tv-line', color: 'accent' },
  { title: '网红八卦汇总', count: 85, icon: 'ri-user-smile-line', color: 'secondary' },
  { title: '影视剧透专区', count: 72, icon: 'ri-film-line', color: 'primary' },
  { title: '时尚穿搭点评', count: 64, icon: 'ri-shirt-line', color: 'accent' },
  { title: '音乐圈大事件', count: 58, icon: 'ri-music-line', color: 'secondary' },
  { title: '商业代言动态', count: 45, icon: 'ri-briefcase-line', color: 'primary' },
  { title: '海外娱乐资讯', count: 39, icon: 'ri-global-line', color: 'accent' },
  { title: '年度吃瓜盘点', count: 32, icon: 'ri-calendar-check-line', color: 'secondary' },
];

export const contactData = {
  title: '有料你就来',
  subtitle: '如果你有独家爆料、内幕消息或精彩故事，欢迎联系我们',
  email: 'tips@chiguaonline.com',
  wechat: 'chigua_tips',
  tips: [
    '爆料内容请确保真实可靠',
    '提供图片或视频证据优先处理',
    '爆料人信息严格保密',
    '重大独家线索可获丰厚奖励',
  ],
};

export const faqData = [
  {
    q: '吃瓜在线的内容更新频率是怎样的？',
    a: '吃瓜在线实行24小时不间断更新机制，编辑团队全天候监控娱乐圈、网红圈、综艺影视等各个领域的最新动态，确保用户第一时间获取今日吃瓜最新资讯。重大事件发生后，我们会在30秒内完成推送通知。',
  },
  {
    q: '如何确保吃瓜在线内容的真实性和可靠性？',
    a: '我们设有专业的内容审核团队，所有今日吃瓜爆料内容发布前均需经过多重核实流程。对于来源不明的爆料信息，我们会明确标注"待核实"标签，并持续跟踪事件进展，确保用户获取准确的今日吃瓜在线观看体验。',
  },
  {
    q: '吃瓜在线支持哪些设备访问？',
    a: '吃瓜在线全面支持PC端浏览器、手机浏览器访问，同时提供51吃瓜视频在线观看功能。您可以在任何设备上流畅浏览今日吃瓜在线观看内容，获得一致的优质体验。我们也在持续优化移动端体验。',
  },
  {
    q: '我想提供爆料线索，应该如何操作？',
    a: '欢迎通过"联系我们"板块提供的邮箱或微信渠道提交爆料线索。请在投稿时尽量提供详细的文字描述和相关证据（如图片、视频等），我们的编辑团队收到后会优先处理并严格保护爆料人隐私信息。',
  },
];

export const carouselData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Stylized%20warm%20abstract%20editorial%20banner%20for%20entertainment%20news%20feature%2C%20soft%20dramatic%20lighting%20with%20peach%20and%20coral%20gradients%2C%20magazine%20cover%20aesthetic%2C%20cinematic%20composition%20with%20flowing%20organic%20shapes%2C%20elegant%20modern%20design%20with%20warm%20ambient%20glow&width=1200&height=600&seq=carousel-gossip-01&orientation=landscape',
    title: '暑期档娱乐圈大事盘点',
    desc: '这个暑假娱乐圈发生了哪些让你意想不到的大事件？',
    label: '热门专题',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20abstract%20feature%20header%20design%2C%20editorial%20magazine%20spread%20style%2C%20soft%20flowing%20gradients%20in%20amber%20and%20cream%2C%20cinematic%20lighting%20with%20gentle%20highlights%2C%20modern%20luxury%20aesthetic%2C%20clean%20sophisticated%20composition&width=1200&height=600&seq=carousel-gossip-02&orientation=landscape',
    title: '网红经济背后的真相',
    desc: '深入探秘网红产业的商业逻辑与不为人知的行业内幕。',
    label: '深度报道',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Artistic%20warm%20abstract%20banner%20with%20entertainment%20theme%2C%20soft%20dramatic%20coral%20and%20terracotta%20colors%2C%20editorial%20photography%20backdrop%2C%20cinematic%20composition%20with%20smooth%20gradients%2C%20modern%20magazine%20layout%20vibe%2C%20elegant%20warm%20lighting%20effect&width=1200&height=600&seq=carousel-gossip-03&orientation=landscape',
    title: '明星片酬大揭秘',
    desc: '从一线大咖到新人演员，他们的真实收入到底有多少？',
    label: '独家揭秘',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Warm%20abstract%20cinematic%20banner%20for%20media%20feature%2C%20soft%20peach%20and%20sand%20color%20palette%2C%20editorial%20magazine%20cover%20style%2C%20flowing%20organic%20shapes%20with%20ambient%20glow%2C%20modern%20elegant%20composition%2C%20clean%20sophisticated%20design&width=1200&height=600&seq=carousel-gossip-04&orientation=landscape',
    title: '年度最甜明星情侣盘点',
    desc: '那些让人羡慕的明星CP，看看谁的爱情最让人心动？',
    label: '甜蜜专题',
  },
];

export const navLinks = [
  { label: '吃瓜热度榜', href: '#ranking' },
  { label: '话题热榜', href: '#topics' },
  { label: '平台特色', href: '#features' },
  { label: '专题索引', href: '#index' },
  { label: '联系我们', href: '#contact' },
  { label: '关于吃瓜在线', href: '#about' },
];